<template>
  <div class="memoirs-page">
    <!-- 共用头部导航栏 -->
    <header-nav></header-nav>

    <!-- 飘落花瓣装饰 -->
    <span v-for="(p, i) in petals" :key="'petal-' + i" class="petal"
          :style="{ left: p.left + '%', width: p.size + 'px', height: p.size + 'px',
                    animationDuration: p.duration + 's', animationDelay: p.delay + 's' }"></span>

    <!-- 顶部横幅 -->
    <header class="hero">
      <div class="hero-inner">
        <p class="hero-kicker">粉裙星物语 · 衣橱时光机</p>
        <h1 class="hero-title">我的照片回忆录</h1>
        <p class="hero-sub">Lolita · JK · 汉服 —— 每一件裙子，都藏着一小段时光</p>
        <div class="hero-stats">
          <div class="stat">
            <b>{{ allPhotos.length }}</b><span>张照片</span>
          </div>
          <div class="stat">
            <b>{{ tabs.length - 1 }}</b><span>种风格</span>
          </div>
          <div class="stat">
            <b>{{ spanYears }}</b><span>年时光</span>
          </div>
        </div>
      </div>
    </header>

    <!-- 风格筛选 -->
    <nav class="filters" aria-label="按风格筛选">
      <button v-for="tab in tabs" :key="tab.value" class="filter-btn"
              :class="{ active: activeTab === tab.value }"
              @click="switchTab(tab.value)">{{ tab.label }}</button>
    </nav>

    <!-- 已隐藏示例找回入口 -->
    <div v-if="hiddenSamples.length" class="restore-bar">
      <button class="restore-btn" @click="restoreVisible = true">
        <span class="restore-ic">🎀</span> 已隐藏 {{ hiddenSamples.length }} 张示例 · 点击找回
      </button>
    </div>

    <!-- 时间线（水平滑动） -->
    <div class="timeline">
      <div :key="activeTab" class="timeline-wrap">
<!--        <p class="timeline-hint">滚轮 / 拖拽 / 按钮，均可左右滑动时间线</p>-->
          <div class="timeline-scroll" ref="scroll">
            <div class="timeline-track">
              <span class="timeline-line"></span>
              <div v-for="item in filteredPhotos" :key="item.mine ? 'mine-' + item.id : 'sample-' + item.id" class="tl-item">
                <div class="tl-node">
                  <span class="tl-dot"></span>
                  <span class="tl-date">{{ item.date }}</span>
                </div>
                <article class="tl-card" @click="openLightbox(item)">
                  <div class="photo">
                    <img :src="item.src" :alt="item.title" loading="lazy" />
                    <span class="cat-tag" :class="item.category">{{ catText(item.category) }}</span>
                    <div class="photo-overlay">
                      <svg class="zoom-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                           stroke-width="2" stroke-linecap="round">
                        <circle cx="11" cy="11" r="7"></circle>
                        <line x1="21" y1="21" x2="16.5" y2="16.5"></line>
                        <line x1="11" y1="8" x2="11" y2="14"></line>
                        <line x1="8" y1="11" x2="14" y2="11"></line>
                      </svg>
                      <span>点击查看大图</span>
                    </div>
                    <!-- 操作按钮：示例照片只能隐藏，自己的照片可编辑/删除 -->
                    <div class="photo-actions">
                      <template v-if="item.mine">
                        <button class="act-btn" title="编辑这张照片" @click.stop="openEdit(item)">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path></svg>
                        </button>
                        <button class="act-btn act-danger" title="删除这张照片" @click.stop="removePhoto(item)">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path></svg>
                        </button>
                      </template>
                      <button v-else class="act-btn" title="隐藏这张示例照片" @click.stop="hideSample(item)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <h3 class="card-title">{{ item.title }}</h3>
                    <p class="card-desc">{{ item.description }}</p>
                    <span v-if="item.mine" class="mine-badge">✦ 我的照片</span>
                  </div>
                </article>
              </div>

              <p v-if="!filteredPhotos.length" class="empty-tip">这个分类下还没有照片，去拍一张吧～</p>

              <!-- 末尾占位卡片：上传自己的照片 -->
              <div class="tl-item tl-add" @click="openAdd">
                <div class="tl-node">
                  <span class="tl-dot add-dot"></span>
                  <span class="tl-date">新的回忆</span>
                </div>
                <div class="tl-card add-card">
                  <div class="add-plus"><span>+</span></div>
                  <p class="add-title">添加照片</p>
                  <span class="add-sub">上传你的裙子时光，写下标题与故事</span>
                </div>
              </div>
            </div>
          </div>

          <button v-if="filteredPhotos.length" class="scroll-btn prev"
                  title="上一张" aria-label="向左滑动" @click="scrollByDir(-1)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 5 8 12 15 19"></polyline>
            </svg>
          </button>
          <button v-if="filteredPhotos.length" class="scroll-btn next"
                  title="下一张" aria-label="向右滑动" @click="scrollByDir(1)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 5 16 12 9 19"></polyline>
            </svg>
          </button>
      </div>
    </div>

    <footer class="page-foot">— 未完待续 · 下一件裙子正在路上 —</footer>

    <!-- 90% 大图预览 -->
    <transition name="lb">
      <div v-if="lightboxVisible" class="lightbox" role="dialog" aria-modal="true"
           @click.self="closeLightbox">
        <div class="lb-stage">
          <button class="lb-btn lb-close" title="关闭 (Esc)" aria-label="关闭预览" @click="closeLightbox">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
              <line x1="5" y1="5" x2="19" y2="19"></line>
              <line x1="19" y1="5" x2="5" y2="19"></line>
            </svg>
          </button>
          <button class="lb-btn lb-prev" title="上一张 (←)" aria-label="上一张" @click="prevPhoto">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 5 8 12 15 19"></polyline>
            </svg>
          </button>

          <figure class="lb-figure" v-if="currentPhoto.src">
            <img :src="currentPhoto.src" :alt="currentPhoto.title" />
            <figcaption class="lb-caption">
              <div class="lb-head">
                <span class="lb-cat" :class="currentPhoto.category">{{ catText(currentPhoto.category) }}</span>
                <h4>{{ currentPhoto.title }}</h4>
                <em>{{ currentPhoto.date }}</em>
              </div>
              <p class="lb-desc">{{ currentPhoto.description }}</p>
            </figcaption>
          </figure>

          <button class="lb-btn lb-next" title="下一张 (→)" aria-label="下一张" @click="nextPhoto">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 5 16 12 9 19"></polyline>
            </svg>
          </button>
          <span class="lb-counter">{{ lightboxIndex + 1 }} / {{ filteredPhotos.length }}</span>
        </div>
      </div>
    </transition>

    <!-- 上传 / 编辑照片弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="460px"
      :show-close="false"
      :close-on-click-modal="false"
      class="memoir-dialog"
    >
      <template #title>
        <span class="dlg-title">{{ dialogMode === 'add' ? '📸 添加回忆照片' : '✏️ 编辑回忆照片' }}</span>
      </template>

      <div class="dlg-body">
        <!-- 上传区 -->
        <div class="upload-box" @click="pickFile">
          <img v-if="form.src" :src="form.src" class="upload-preview" alt="预览" />
          <div v-else class="upload-empty">
            <span class="up-plus">+</span>
            <p>点击上传照片</p>
            <em>支持 JPG / PNG，自动压缩</em>
          </div>
        </div>
        <input ref="fileInput" type="file" accept="image/*" class="file-hidden" @change="onFileChange" />

        <div class="dlg-row">
          <label class="dlg-label">标题</label>
          <el-input v-model="form.title" placeholder="给这段时光起个名字" maxlength="30" clearable />
        </div>
        <div class="dlg-row">
          <label class="dlg-label">时间</label>
          <el-date-picker
            v-model="form.date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择这张照片的时间"
            class="date-picker"
          />
        </div>
        <div class="dlg-row">
          <label class="dlg-label">描述</label>
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="写几句当时的故事…" maxlength="120" />
        </div>
        <div class="dlg-row">
          <label class="dlg-label">分类</label>
          <div class="cat-line">
            <el-select v-model="form.category" placeholder="选择风格" class="cat-select">
              <el-option v-for="c in catOptions" :key="c.value" :label="c.label" :value="c.value" />
            </el-select>
            <el-input v-model="newCat" placeholder="或新建分类" maxlength="8" class="new-cat" @keyup.enter.native="applyNewCat" />
            <el-button v-if="newCat.trim()" class="cat-add-btn" @click="applyNewCat">添加</el-button>
          </div>
          <p class="cat-hint">新建的分类会出现在顶部筛选与下次上传的选择里</p>
        </div>
      </div>

      <template #footer>
        <el-button class="dlg-cancel" @click="closeDialog">取消</el-button>
        <el-button type="primary" class="dlg-save" :loading="saving" @click="savePhoto">{{ dialogMode === 'add' ? '保存照片' : '保存修改' }}</el-button>
      </template>
    </el-dialog>

    <!-- 找回隐藏的示例照片 -->
    <el-dialog
      :visible.sync="restoreVisible"
      width="420px"
      :show-close="false"
      :close-on-click-modal="true"
      class="memoir-dialog restore-dialog"
    >
      <template #title>
        <span class="dlg-title">🎀 找回隐藏的示例</span>
      </template>

      <div v-if="hiddenSampleList.length" class="restore-list">
        <div v-for="s in hiddenSampleList" :key="s.id" class="restore-item">
          <img :src="s.src" class="restore-thumb" :alt="s.title" />
          <div class="restore-info">
            <p class="restore-name">{{ s.title }}</p>
            <span class="restore-cat">{{ catText(s.category) }}</span>
          </div>
          <button class="restore-item-btn" @click="restoreSample(s)">恢复</button>
        </div>
      </div>
      <p v-else class="restore-empty">没有隐藏的示例，快去时光里逛逛吧～</p>

      <template #footer>
        <el-button class="dlg-cancel" @click="restoreVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import lolita1 from '../../assets/memoirs/lolita-1.jpg'
import lolita2 from '../../assets/memoirs/lolita-2.jpg'
import jk1 from '../../assets/memoirs/jk-1.jpg'
import jk2 from '../../assets/memoirs/jk-2.jpg'
import hanfu1 from '../../assets/memoirs/hanfu-1.jpg'
import hanfu2 from '../../assets/memoirs/hanfu-2.jpg'
import HeaderNav from '../HeaderNav.vue'
import bus from '../../utils/bus'

export default {
  name: 'Memoirs',
  components: { HeaderNav },
  data() {
    return {
      activeTab: 'all',
      lightboxVisible: false,
      lightboxIndex: 0,
      // 登录状态（响应式：登录/切换账号时即时更新，无需刷新页面）
      loggedIn: false,
      // 当前登录用户（sessionStorage CurUser）
      user: null,
      // 保存/上传中标志
      saving: false,
      // 示例分类（每个账号共有的基础风格）
      baseCats: [
        { label: 'Lolita', value: 'lolita' },
        { label: 'JK制服', value: 'jk' },
        { label: '汉服', value: 'hanfu' }
      ],
      // 用户自定义分类（按账号存储在 localStorage）
      customCats: [],
      // 当前账号隐藏的示例照片 id（只是隐藏，未删除）
      hiddenSamples: [],
      // 当前账号自己上传的照片（localStorage 持久化）
      userPhotos: [],
      // 上传/编辑弹窗状态
      dialogVisible: false,
      dialogMode: 'add',
      newCat: '',
      form: { src: '', imgUrl: '', title: '', description: '', category: '', date: '' },
      editingId: null,
      // 找回隐藏示例弹窗
      restoreVisible: false,
      // 示例照片数据：每个账号都有的共同示例，不可编辑，可隐藏
      samplePhotos: [
        {
          id: 1,
          sample: true,
          title: '春日茶会 · 第一件小裙子',
          date: '2024.03',
          category: 'lolita',
          src: lolita1,
          description: '入坑的第一条洛丽塔，粉色蕾丝像奶油一样层层堆叠。那天樱花刚好开了七成，我穿着它在院子里转圈，裙摆扫过满地花瓣——原来女孩子真的会为一条裙子开心一整天。'
        },
        {
          id: 2,
          sample: true,
          title: '盛夏操场 · 水手服',
          date: '2024.08',
          category: 'jk',
          src: jk1,
          description: '绀色水手服配上百褶裙，是学生时代最标准的青春。八月的操场热得冒烟，我却舍不得脱下这身衣服——大概是第一次觉得，校服原来也可以这么好看。'
        },
        {
          id: 3,
          sample: true,
          title: '桃花未开 · 齐胸襦裙',
          date: '2025.01',
          category: 'hanfu',
          src: hanfu1,
          description: '新年第一套汉服选了粉色齐胸襦裙，大袖被风扬起来的时候，终于懂了什么叫"衣袂飘飘"。园子里的桃树还是光秃秃的，但照片里的春天，已经提前到了。'
        },
        {
          id: 4,
          sample: true,
          title: '书房午后 · 暗黑甜心',
          date: '2025.05',
          category: 'lolita',
          src: lolita2,
          description: '黑色蕾丝与缎带叠出满满的仪式感，坐在旧书房的窗边，光刚好落在裙摆上。都说甜系才是洛丽塔的标配，可我觉得，深色系里藏着更安静的浪漫。'
        },
        {
          id: 5,
          sample: true,
          title: '古镇深秋 · 格纹西装',
          date: '2025.10',
          category: 'jk',
          src: jk2,
          description: '秋天和格纹是天生一对。抱着课本走过青石板路，暖阳把影子拉得很长，这一刻忽然很像日剧里的某个镜头——没有台词，但风很温柔。'
        },
        {
          id: 6,
          sample: true,
          title: '红墙之下 · 马面裙',
          date: '2026.03',
          category: 'hanfu',
          src: hanfu2,
          description: '明制的红金马面裙一上身就莫名端重起来，站在朱红宫墙前，团扇半掩，感觉自己真的把一段旧时光穿在了身上。三月的风还凉，心里却是滚烫的。'
        }
      ],
      petals: Array.from({ length: 10 }, (_, i) => ({
        left: (i * 97) % 100,
        size: 8 + ((i * 13) % 7),
        duration: 9 + ((i * 5) % 7),
        delay: -((i * 3.7) % 12)
      }))
    }
  },
  computed: {
    // 全部照片 = 未隐藏的示例 + 用户上传，按时间线升序排列
    allPhotos() {
      const samples = this.samplePhotos.filter(p => this.hiddenSamples.indexOf(p.id) < 0)
      const mine = this.userPhotos.map(p => ({ ...p, mine: true }))
      return [...samples, ...mine].sort((a, b) => {
        const da = String(a.date || '').replace('.', '')
        const db = String(b.date || '').replace('.', '')
        return da.localeCompare(db)
      })
    },
    // 顶部筛选：全部 + 基础分类 + 用户自定义分类
    tabs() {
      const base = [{ label: '全部', value: 'all' }].concat(this.baseCats)
      const extra = this.customCats.map(c => ({ label: c, value: c }))
      return base.concat(extra)
    },
    // 可选的分类（弹窗下拉）
    catOptions() {
      return this.baseCats.concat(this.customCats.map(c => ({ label: c, value: c })))
    },
    filteredPhotos() {
      if (this.activeTab === 'all') return this.allPhotos
      return this.allPhotos.filter(p => p.category === this.activeTab)
    },
    currentPhoto() {
      return this.filteredPhotos[this.lightboxIndex] || this.filteredPhotos[0] || {}
    },
    // 当前账号隐藏的示例（用于找回）
    hiddenSampleList() {
      return this.samplePhotos.filter(p => this.hiddenSamples.indexOf(p.id) >= 0)
    },
    spanYears() {
      const years = this.allPhotos
        .map(p => parseInt(String(p.date || '').slice(0, 4), 10))
        .filter(y => !isNaN(y))
      if (!years.length) return 1
      return Math.max.apply(null, years) - Math.min.apply(null, years) + 1
    }
  },
  watch: {
    lightboxVisible(val) {
      document.body.style.overflow = val ? 'hidden' : ''
      if (val) window.addEventListener('keydown', this.onKeydown)
      else window.removeEventListener('keydown', this.onKeydown)
    }
  },
  mounted() {
    this.loggedIn = this.checkLoggedIn()
    this.readLoginUser()
    this.loadUserData()
    bus.$on('user-changed', this.onUserChanged)
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) en.target.classList.add('in-view')
      })
    }, { threshold: 0.2 })
    this.observeItems()
    this.attachWheel()
  },
  beforeDestroy() {
    bus.$off('user-changed', this.onUserChanged)
    if (this.observer) this.observer.disconnect()
    if (this._wheelHandler) this.$el.removeEventListener('wheel', this._wheelHandler)
    window.removeEventListener('keydown', this.onKeydown)
    document.body.style.overflow = ''
  },
  methods: {
    // ============ 按账号存取数据（示例隐藏 / 自定义分类用 localStorage，照片存后端） ============
    userKey() {
      const no = this.user && this.user.no ? String(this.user.no) : ''
      return no ? 'u_' + no : 'guest'
    },
    loadUserData() {
      const key = this.userKey()
      this.hiddenSamples = this.safeGet('memoirs_hidden_' + key, [])
      this.customCats = this.safeGet('memoirs_cats_' + key, [])
      // 照片元数据存数据库，按账号从后端加载；未登录不展示任何用户照片
      if (this.user && this.user.no) {
        this.loadUserPhotos()
      } else {
        this.userPhotos = []
      }
    },
    loadUserPhotos() {
      if (!this.user || !this.user.no) return
      this.$axios.get(this.$httpUrl + '/memoir/list', {
        params: { userNo: this.user.no }
      }).then(res => {
        if (res.data && res.data.code == 200) {
          this.userPhotos = (res.data.data || []).map(p => ({
            id: p.id,
            title: p.title,
            description: p.description || '',
            category: p.category || '',
            date: p.photoDate || '',
            src: this.imgUrl(p.imgUrl),
            imgUrl: p.imgUrl
          }))
          // 列表重建后重新触发淡入观察，否则新卡片 opacity 0 不可见
          this.$nextTick(() => this.observeItems())
        } else {
          this.$message({ message: (res.data && res.data.msg) || '加载失败', type: 'error' })
        }
      }).catch(() => {
        this.$message({ message: '加载时光相册失败，请检查网络', type: 'error' })
      })
    },
    imgUrl(path) {
      if (!path) return ''
      if (/^https?:\/\//.test(path)) return path
      return this.$httpUrl + path
    },
    uploadImage(blob) {
      const fd = new FormData()
      fd.append('file', blob, 'memoir_' + Date.now() + '.jpg')
      return this.$axios.post(this.$httpUrl + '/memoir/api/uploadMemoirImg', fd).then(res => {
        if (res.data && res.data.success && res.data.filePath) {
          return res.data.filePath
        }
        throw new Error((res.data && res.data.message) || '图片上传失败')
      })
    },
    onUserChanged() {
      // 登录/切换账号后立即刷新登录标志与该账号自己的数据（无需刷新页面）
      this.loggedIn = this.checkLoggedIn()
      this.readLoginUser()
      this.loadUserData()
      this.closeDialog()
    },
    checkLoggedIn() {
      return !!sessionStorage.getItem('CurUser')
    },
    readLoginUser() {
      try {
        const cu = sessionStorage.getItem('CurUser')
        this.user = cu ? JSON.parse(cu) : null
      } catch (e) {
        this.user = null
      }
    },
    safeGet(name, fallback) {
      try {
        const raw = localStorage.getItem(name)
        const val = raw ? JSON.parse(raw) : fallback
        return Array.isArray(val) ? val : fallback
      } catch (e) {
        return fallback
      }
    },
    saveHidden() {
      try { localStorage.setItem('memoirs_hidden_' + this.userKey(), JSON.stringify(this.hiddenSamples)) } catch (e) {}
    },
    saveCats() {
      try { localStorage.setItem('memoirs_cats_' + this.userKey(), JSON.stringify(this.customCats)) } catch (e) {}
    },
    // ============ 添加 / 编辑 / 删除 / 隐藏 ============
    openAdd() {
      if (!this.loggedIn) {
        this.$message.warning('请先登录，登录后才能上传自己的照片')
        return
      }
      this.dialogMode = 'add'
      this.editingId = null
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      this.form = { src: '', imgUrl: '', title: '', description: '', category: '', date: y + '-' + m }
      this._pendingFile = null
      this.newCat = ''
      this.dialogVisible = true
    },
    openEdit(item) {
      if (!item.mine) return
      this.dialogMode = 'edit'
      this.editingId = item.id
      this.form = {
        src: item.src,
        imgUrl: item.imgUrl || '',
        title: item.title,
        description: item.description,
        category: item.category,
        date: String(item.date || '').replace('.', '-')
      }
      this._pendingFile = null
      this.newCat = ''
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.newCat = ''
    },
    pickFile() {
      if (this.$refs.fileInput) this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      if (file.type.indexOf('image/') !== 0) {
        this.$message.error('只能上传图片文件')
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片不能超过 10MB')
        return
      }
      this.compressImage(file).then(({ dataUrl, blob }) => {
        this.form.src = dataUrl
        // 压缩后的图片等待保存时上传到后端（user-img 目录）
        this._pendingFile = blob
      }).catch(() => {
        this.$message.error('图片读取失败，请换一张试试')
      })
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
          const MAX = 900
          const scale = Math.min(1, MAX / Math.max(img.width, img.height))
          const w = Math.max(1, Math.round(img.width * scale))
          const h = Math.max(1, Math.round(img.height * scale))
          const canvas = document.createElement('canvas')
          canvas.width = w
          canvas.height = h
          const ctx = canvas.getContext('2d')
          ctx.fillStyle = '#fff'
          ctx.fillRect(0, 0, w, h)
          ctx.drawImage(img, 0, 0, w, h)
          URL.revokeObjectURL(url)
          const dataUrl = canvas.toDataURL('image/jpeg', 0.82)
          canvas.toBlob(blob => {
            resolve({ dataUrl, blob })
          }, 'image/jpeg', 0.82)
        }
        img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('read fail')) }
        img.src = url
      })
    },
    applyNewCat() {
      const name = this.newCat.trim()
      if (!name) return
      if (this.customCats.indexOf(name) >= 0) {
        this.form.category = name
        this.newCat = ''
        this.$message({ type: 'info', message: '该分类已存在，已为你选中' })
        return
      }
      this.customCats.push(name)
      this.saveCats()
      this.form.category = name
      this.newCat = ''
      this.$message.success('已新建分类「' + name + '」')
    },
    async savePhoto() {
      if (!this.form.src) {
        this.$message.warning('请先上传照片')
        return
      }
      if (!this.form.title.trim()) {
        this.$message.warning('请填写标题')
        return
      }
      if (!this.form.date) {
        this.$message.warning('请选择时间')
        return
      }
      this.saving = true
      try {
        // 有新选图片（本地压缩预览）→ 先上传到后端 user-img 目录拿到 URL
        let imgUrl = this.form.imgUrl
        if (this._pendingFile) {
          imgUrl = await this.uploadImage(this._pendingFile)
        }
        if (!imgUrl) {
          this.$message.warning('图片尚未上传成功')
          this.saving = false
          return
        }
        const payload = {
          id: this.editingId,
          userNo: this.user.no,
          title: this.form.title.trim(),
          description: this.form.description.trim(),
          category: this.form.category || '',
          photoDate: String(this.form.date).replace('-', '.'),
          imgUrl
        }
        const url = '/memoir/' + (this.dialogMode === 'add' ? 'save' : 'update')
        const res = await this.$axios.post(this.$httpUrl + url, payload)
        if (res.data && res.data.code == 200) {
          this.$message.success(this.dialogMode === 'add' ? '照片已加入回忆录' : '已保存修改')
          this.closeDialog()
          // 无论之前在哪个分类下，保存后自动切回「全部」，确保新照片立即可见
          this.activeTab = 'all'
          // 从后端重新加载，保持与数据库一致
          this.loadUserPhotos()
          // 等列表渲染后自动横向滚动到最右（新照片所在位置）
          setTimeout(() => {
            const scroller = this.$el && this.$el.querySelector('.timeline-scroll')
            if (scroller) scroller.scrollLeft = scroller.scrollWidth
          }, 350)
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败')
        }
      } catch (err) {
        this.$message.error((err && err.message) || '保存失败，请稍后重试')
      } finally {
        this.saving = false
      }
    },
    hideSample(item) {
      if (!this.loggedIn) {
        this.$message.warning('未登录没有操作权限，请先登录')
        return
      }
      this.$confirm('隐藏这张示例照片？隐藏后它不再显示（只对当前账号生效，其它账号依旧能看到示例）。', '隐藏示例', {
        confirmButtonText: '隐藏',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.hiddenSamples.indexOf(item.id) < 0) this.hiddenSamples.push(item.id)
        this.saveHidden()
        this.$message.success('已隐藏这张示例照片')
      }).catch(() => {})
    },
    removePhoto(item) {
      if (!item.mine) return
      this.$confirm('确定删除这张照片吗？删除后无法恢复。', '删除照片', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$httpUrl + '/memoir/delete', {
          id: item.id,
          userNo: this.user.no
        }).then(res => {
          if (res.data && res.data.code == 200) {
            this.userPhotos = this.userPhotos.filter(p => p.id !== item.id)
            this.$message.success('已删除这张照片')
          } else {
            this.$message.error((res.data && res.data.msg) || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败，请检查网络')
        })
      }).catch(() => {})
    },
    restoreSample(s) {
      const idx = this.hiddenSamples.indexOf(s.id)
      if (idx >= 0) this.hiddenSamples.splice(idx, 1)
      this.saveHidden()
      if (!this.hiddenSamples.length) this.restoreVisible = false
      this.$message.success('已恢复「' + s.title + '」')
    },
    catText(c) {
      return { lolita: 'Lolita', jk: 'JK', hanfu: '汉服' }[c] || c
    },
    switchTab(val) {
      this.activeTab = val
      this.closeLightbox()
      this.$nextTick(() => this.observeItems())
    },
    observeItems() {
      if (!this.observer) return
      const items = this.$el.querySelectorAll('.tl-item')
      items.forEach(el => {
        el.classList.remove('in-view')
        this.observer.unobserve(el)
        this.observer.observe(el)
      })
    },
    // 鼠标滚轮 → 左右滑动
    attachWheel() {
      this._wheelHandler = (e) => {
        if (this.lightboxVisible) return
        if (!(e.target instanceof Element)) return
        if (!e.target.closest('.timeline')) return
        e.preventDefault()
        const scroller = this.$el.querySelector('.timeline-scroll')
        if (!scroller) return
        const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 100 : 1
        const delta = e.deltaY !== 0 ? e.deltaY : e.deltaX
        scroller.scrollLeft += delta * unit
      }
      this.$el.addEventListener('wheel', this._wheelHandler, { passive: false })
    },
    scrollByDir(dir) {
      const scroller = this.$el.querySelector('.timeline-scroll')
      if (scroller) scroller.scrollBy({ left: dir * 320, behavior: 'smooth' })
    },
    openLightbox(item) {
      // 示例 id(1~6) 与数据库自增 id 可能重复，用对象引用定位；兜底用 mine+id 组合
      const idx = this.filteredPhotos.findIndex(
        p => p === item || (Boolean(p.mine) === Boolean(item.mine) && p.id === item.id)
      )
      this.lightboxIndex = idx >= 0 ? idx : 0
      this.lightboxVisible = true
    },
    closeLightbox() {
      this.lightboxVisible = false
    },
    prevPhoto() {
      const len = this.filteredPhotos.length
      if (!len) return
      this.lightboxIndex = (this.lightboxIndex - 1 + len) % len
    },
    nextPhoto() {
      const len = this.filteredPhotos.length
      if (!len) return
      this.lightboxIndex = (this.lightboxIndex + 1) % len
    },
    onKeydown(e) {
      if (!this.lightboxVisible) return
      if (e.key === 'Escape') this.closeLightbox()
      else if (e.key === 'ArrowLeft') this.prevPhoto()
      else if (e.key === 'ArrowRight') this.nextPhoto()
    }
  }
}
</script>

<style scoped>
.memoirs-page {
  position: relative;
  width: 100%;
  height: 100vh;
  padding-top: 60px; /* 为固定头部导航栏让位 */
  box-sizing: border-box;
  overflow: hidden;
  background: linear-gradient(180deg, #fff5f9 0%, #fdeef3 35%, #fff6f1 70%, #fff9f4 100%);
  color: #5d4650;
  font-family: "PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", sans-serif;
}

/* ===== 飘落花瓣 ===== */
.petal {
  position: fixed;
  top: -5vh;
  border-radius: 60% 40% 60% 40%;
  background: linear-gradient(135deg, #ffd9e8, #ffb3d1);
  opacity: 0;
  pointer-events: none;
  z-index: 1;
  animation-name: petal-fall;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes petal-fall {
  0%   { transform: translate3d(0, 0, 0) rotate(0deg); opacity: 0; }
  8%   { opacity: 0.75; }
  50%  { transform: translate3d(4vw, 50vh, 0) rotate(170deg); opacity: 0.7; }
  100% { transform: translate3d(-3vw, 108vh, 0) rotate(340deg); opacity: 0; }
}

/* ===== 顶部横幅 ===== */
.hero {
  position: relative;
  z-index: 2;
  padding: 15px 24px 10px;
  text-align: center;
}
.hero::before,
.hero::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  pointer-events: none;
}
.hero::before {
  width: 420px;
  height: 420px;
  top: -120px;
  left: -100px;
  background: rgba(255, 182, 210, 0.45);
}
.hero::after {
  width: 380px;
  height: 380px;
  top: -80px;
  right: -110px;
  background: rgba(255, 214, 190, 0.5);
}
.hero-inner {
  position: relative;
  animation: hero-in 0.9s ease both;
}
@keyframes hero-in {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}
.hero-kicker {
  margin: 0 0 10px;
  font-size: 15px;
  letter-spacing: 6px;
  color: #e58fb0;
  font-weight: 500;
}
.hero-title {
  margin: 0 0 14px;
  font-size: 46px;
  line-height: 1.2;
  color: #d95f8d;
  font-family: "STKaiti", "KaiTi", "Georgia", serif;
  font-weight: 700;
  letter-spacing: 6px;
}
.hero-sub {
  margin: 0 0 10px;
  font-size: 16px;
  color: #a2848f;
  letter-spacing: 1px;
}
.hero-stats {
  display: flex;
  justify-content: center;
  gap: 42px;
}
.stat b {
  display: block;
  font-size: 30px;
  color: #f06ba0;
  font-family: "Georgia", serif;
  line-height: 1.1;
}
.stat span {
  font-size: 13px;
  color: #b3949f;
  letter-spacing: 2px;
}

/* ===== 风格筛选 ===== */
.filters {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 10px 16px;
  background: rgba(255, 246, 249, 0.82);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 1px 0 rgba(233, 140, 175, 0.18);
}
.filter-btn {
  padding: 5px 15px;
  border: 1px solid #f3c6d8;
  border-radius: 999px;
  background: #fff;
  color: #c96f96;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.filter-btn:hover {
  border-color: #f06ba0;
  color: #e2568b;
  transform: translateY(-1px);
}
.filter-btn.active {
  background: linear-gradient(135deg, #f78fc0, #e85f96);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 6px 16px rgba(232, 95, 150, 0.35);
}

/* ===== 时间线（水平滑动） ===== */
.timeline {
  position: relative;
  z-index: 2;
  margin: 0 auto;
  padding: 0 0 8px;
}
.timeline-wrap {
  position: relative;
  padding: 0 64px;
}
.timeline-hint {
  margin: 0 0 16px;
  text-align: center;
  font-size: 13px;
  letter-spacing: 2px;
  color: #c9a3b2;
}
.timeline-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 5px 0 20px;
  cursor: grab;
  scrollbar-width: thin;
  scrollbar-color: #f2a8c6 transparent;
}
.timeline-scroll:active {
  cursor: grabbing;
}
.timeline-scroll::-webkit-scrollbar {
  height: 8px;
}
.timeline-scroll::-webkit-scrollbar-track {
  background: rgba(244, 114, 166, 0.08);
  border-radius: 8px;
}
.timeline-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #f7a9cb, #ef7fae);
  border-radius: 8px;
}
.timeline-track {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 35px;
  min-width: max-content;
  padding: 0 4vw;
}
.timeline-line {
  position: absolute;
  top: 15px;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 3px;
  pointer-events: none;
  background: linear-gradient(90deg,
    rgba(247, 143, 192, 0.12),
    rgba(247, 143, 192, 0.85) 12%,
    rgba(255, 197, 219, 0.6) 50%,
    rgba(240, 107, 160, 0.85) 88%,
    rgba(240, 107, 160, 0.12));
}
.tl-item {
  flex-shrink: 0;
  width: 300px;
  //max-height: 750px;
  //height: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}
.tl-item.in-view {
  opacity: 1;
  transform: translateY(0);
}
.tl-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 60px;
}
.tl-dot {
  position: relative;
  z-index: 1;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  border: 4px solid #f472a6;
  box-shadow: 0 0 0 4px rgba(244, 114, 166, 0.18);
  margin-top: 6px;
  //margin-bottom: 1px;
}
.tl-dot::after {
  content: '';
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 2px solid rgba(244, 114, 166, 0.4);
  animation: dot-pulse 2.2s ease-out infinite;
}
@keyframes dot-pulse {
  0%   { transform: scale(0.6); opacity: 1; }
  100% { transform: scale(1.5); opacity: 0; }
}
.tl-date {
  padding: 3px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #f6cfe0;
  color: #d96a98;
  font-size: 13px;
  letter-spacing: 1px;
  font-family: "Georgia", "STKaiti", serif;
  white-space: nowrap;
}

/* ===== 卡片 ===== */
.tl-card {
  width: 100%;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(214, 130, 165, 0.16);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}
.tl-item:nth-child(odd) .tl-card {
  transform: rotate(-2deg);
}
.tl-item:nth-child(even) .tl-card {
  transform: rotate(1.5deg);
}
.tl-card:hover {
  transform: rotate(0deg) translateY(-6px) !important;
  box-shadow: 0 18px 42px rgba(214, 130, 165, 0.28);
}
.photo {
  position: relative;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  background: #fbeef3;
}
.photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.55s ease;
}
.tl-card:hover .photo img {
  transform: scale(1.07);
}
.photo-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  letter-spacing: 2px;
  background: rgba(60, 28, 44, 0.32);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.tl-card:hover .photo-overlay {
  opacity: 1;
}
.zoom-icon {
  width: 34px;
  height: 34px;
}
.cat-tag {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 5px 13px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  letter-spacing: 1px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
}
.cat-tag.lolita { background: linear-gradient(135deg, #f78fc0, #e85f96); }
.cat-tag.jk     { background: linear-gradient(135deg, #6fa7d8, #3f79b8); }
.cat-tag.hanfu  { background: linear-gradient(135deg, #e0847f, #c05656); }
.card-body {
  padding: 18px 20px 22px;
}
.card-title {
  margin: 0 0 10px;
  font-size: 18px;
  color: #b84d78;
  font-weight: 600;
  letter-spacing: 1px;
}
.card-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.85;
  color: #8b707c;
}

.empty-tip {
  flex-shrink: 0;
  width: 360px;
  text-align: center;
  color: #c9a3b2;
  padding: 60px 0;
  letter-spacing: 1px;
}

/* 左右滑动按钮 */
.scroll-btn {
  position: absolute;
  top: 46%;
  transform: translateY(-50%);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid #f3c6d8;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #e2568b;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(214, 130, 165, 0.25);
  transition: all 0.25s ease;
}
.scroll-btn:hover {
  background: linear-gradient(135deg, #f78fc0, #e85f96);
  border-color: transparent;
  color: #fff;
  transform: translateY(-50%) scale(1.06);
}
.scroll-btn svg {
  width: 20px;
  height: 20px;
}
.scroll-btn.prev { left: 10px; }
.scroll-btn.next { right: 10px; }

/* ===== 页脚 ===== */
.page-foot {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 10px 0 10px;
  color: #d9a8bd;
  font-size: 14px;
  letter-spacing: 3px;
  font-family: "STKaiti", "KaiTi", serif;
}

/* ===== 大图预览（90%） ===== */
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 18, 27, 0.86);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.lb-stage {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.lb-figure {
  display: flex;
  flex-direction: column;
  max-width: 90vw;
  max-height: 90vh;
  margin: 0;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
  animation: lb-zoom 0.32s cubic-bezier(0.2, 0.8, 0.3, 1) both;
}
@keyframes lb-zoom {
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
}
.lb-figure img {
  display: block;
  max-width: 90vw;
  max-height: calc(90vh - 132px);
  object-fit: contain;
  background: #1c0f16;
}
.lb-caption {
  flex-shrink: 0;
  padding: 14px 22px 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.1));
}
.lb-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.lb-cat {
  padding: 3px 12px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
}
.lb-cat.lolita { background: linear-gradient(135deg, #f78fc0, #e85f96); }
.lb-cat.jk     { background: linear-gradient(135deg, #6fa7d8, #3f79b8); }
.lb-cat.hanfu  { background: linear-gradient(135deg, #e0847f, #c05656); }
.lb-head h4 {
  margin: 0;
  font-size: 17px;
  color: #fff;
  letter-spacing: 1px;
}
.lb-head em {
  font-style: normal;
  font-size: 13px;
  color: #ffc7dd;
  font-family: "Georgia", serif;
}
.lb-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: #f3d9e4;
  max-height: 66px;
  overflow: auto;
}
.lb-btn {
  position: absolute;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;
}
.lb-btn:hover {
  background: rgba(244, 114, 166, 0.85);
  transform: scale(1.06);
}
.lb-btn svg {
  width: 22px;
  height: 22px;
}
.lb-close { top: 26px; right: 30px; }
.lb-prev  { left: 26px; top: 50%; transform: translateY(-50%); }
.lb-next  { right: 26px; top: 50%; transform: translateY(-50%); }
.lb-prev:hover, .lb-next:hover { transform: translateY(-50%) scale(1.06); }
.lb-counter {
  position: absolute;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  color: #ffd6e5;
  font-size: 14px;
  letter-spacing: 2px;
  font-family: "Georgia", serif;
}

/* 预览出现/消失 */
.lb-enter-active { transition: opacity 0.28s ease; }
.lb-enter { opacity: 0; }
.lb-leave-active { transition: opacity 0.24s ease; }
.lb-leave-to { opacity: 0; }

/* ===== 卡片操作按钮（示例=隐藏，我的=编辑/删除） ===== */
.photo-actions {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.25s ease, transform 0.25s ease;
  z-index: 3;
}
.tl-card:hover .photo-actions {
  opacity: 1;
  transform: translateY(0);
}
.act-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #d95f8d;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(120, 50, 80, 0.25);
  transition: all 0.22s ease;
}
.act-btn svg {
  width: 16px;
  height: 16px;
}
.act-btn:hover {
  background: linear-gradient(135deg, #f78fc0, #e85f96);
  color: #fff;
  transform: scale(1.08);
}
.act-btn.act-danger:hover {
  background: linear-gradient(135deg, #f08a8a, #d95555);
  color: #fff;
}
.mine-badge {
  display: inline-block;
  margin-top: 10px;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 1px;
  color: #fff;
  background: linear-gradient(135deg, #f7a3c8, #ec7bad);
  box-shadow: 0 4px 10px rgba(232, 110, 160, 0.3);
}

/* ===== 末尾占位卡片（上传入口） ===== */
.tl-add {
  cursor: pointer;
}
.add-dot {
  border-color: #e8a7c6;
}
.add-dot::after {
  border-color: rgba(232, 167, 198, 0.4);
}
.tl-card.add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 420px;
  border: 2px dashed #f2b7d3;
  background: rgba(255, 250, 252, 0.75);
  cursor: pointer;
  box-shadow: none;
  transform: none;
  transition: all 0.3s ease;
}
.tl-item:nth-child(odd) .tl-card.add-card,
.tl-item:nth-child(even) .tl-card.add-card {
  transform: none;
}
.tl-card.add-card:hover {
  transform: translateY(-6px) !important;
  border-color: #f06ba0;
  background: linear-gradient(160deg, #fff7fb, #ffeef5);
  box-shadow: 0 18px 42px rgba(214, 130, 165, 0.24);
}
.add-plus {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f9a9cc, #ee79af);
  color: #fff;
  font-size: 40px;
  font-weight: 300;
  line-height: 1;
  box-shadow: 0 10px 24px rgba(238, 121, 175, 0.4);
  transition: transform 0.3s ease;
}
.tl-card.add-card:hover .add-plus {
  transform: rotate(90deg) scale(1.06);
}
.add-title {
  margin: 18px 0 6px;
  font-size: 18px;
  color: #d95f8d;
  font-weight: 600;
  letter-spacing: 2px;
}
.add-sub {
  font-size: 13px;
  color: #b3949f;
  letter-spacing: 1px;
  padding: 0 18px;
  text-align: center;
}

/* ===== 上传 / 编辑弹窗 ===== */
.file-hidden {
  display: none;
}
/* Element UI 2.x 的 class 透传落在 .el-dialog__wrapper（外层遮罩）上，
   圆角必须作用于内层 .el-dialog，需用 /deep/ 穿透 scoped */
/deep/ .el-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(150, 60, 100, 0.35);
}
.dlg-title {
  font-size: 17px;
  font-weight: 600;
  color: #d95f8d;
  letter-spacing: 1px;
}
.dlg-body {
  padding: 0 6px;
}
.upload-box {
  width: 100%;
  height: 200px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(160deg, #fff5fa, #ffeef5);
  border: 2px dashed #f2b7d3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.25s ease, background 0.25s ease;
  margin-bottom: 16px;
}
.upload-box:hover {
  border-color: #f06ba0;
  background: linear-gradient(160deg, #fff0f7, #ffe9f3);
}
.upload-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.upload-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #c96f96;
}
.up-plus {
  font-size: 46px;
  font-weight: 300;
  color: #ee79af;
  line-height: 1;
}
.upload-empty p {
  margin: 0;
  font-size: 15px;
  letter-spacing: 1px;
}
.upload-empty em {
  font-style: normal;
  font-size: 12px;
  color: #c9a3b2;
}
.dlg-row {
  margin-bottom: 14px;
}
.dlg-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #a2848f;
  letter-spacing: 1px;
}
.cat-line {
  display: flex;
  gap: 8px;
  align-items: center;
}
.date-picker {
  width: 100%;
}
.date-picker.el-date-editor {
  width: 100%;
}
.cat-select {
  flex: 1;
}
.new-cat {
  width: 130px;
}
.cat-add-btn.el-button {
  margin: 0;
  background: linear-gradient(135deg, #f9a9cc, #ee79af);
  border: none;
  color: #fff;
  border-radius: 999px;
  padding: 9px 16px;
}
.cat-add-btn.el-button:hover {
  background: linear-gradient(135deg, #f7a3c8, #e85f96);
  color: #fff;
}
.cat-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #c9a3b2;
}
.dlg-cancel.el-button {
  border-radius: 999px;
  color: #b3949f;
}
.dlg-save.el-button {
  border-radius: 999px;
  background: linear-gradient(135deg, #f9a9cc, #ee79af);
  border: none;
  color: #fff;
  padding: 10px 24px;
  letter-spacing: 1px;
}
.dlg-save.el-button:hover {
  background: linear-gradient(135deg, #f7a3c8, #e85f96);
  color: #fff;
}

/* ===== 找回隐藏示例 ===== */
.restore-bar {
  position: relative;
  z-index: 2;
  text-align: center;
  margin: 2px 0 6px;
}
.restore-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 18px;
  border: 1px dashed #f2b7d3;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  color: #c96f96;
  font-size: 13px;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.restore-btn:hover {
  border-color: #f06ba0;
  background: linear-gradient(135deg, #fff7fb, #ffeef5);
  color: #e2568b;
  transform: translateY(-1px);
}
.restore-ic {
  font-size: 14px;
}
.restore-list {
  max-height: 420px;
  overflow-y: auto;
  padding: 0 4px;
}
.restore-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(160deg, #fff7fb, #ffeef5);
  margin-bottom: 10px;
}
.restore-thumb {
  width: 56px;
  height: 56px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(180, 90, 130, 0.18);
}
.restore-info {
  flex: 1;
  min-width: 0;
}
.restore-name {
  margin: 0 0 5px;
  font-size: 14px;
  color: #b84d78;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.restore-cat {
  font-size: 12px;
  color: #fff;
  padding: 2px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f9a9cc, #ee79af);
}
.restore-item-btn {
  flex-shrink: 0;
  padding: 6px 16px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(135deg, #f9a9cc, #ee79af);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  letter-spacing: 1px;
  transition: all 0.22s ease;
}
.restore-item-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(232, 95, 150, 0.35);
}
.restore-empty {
  text-align: center;
  padding: 30px 0;
  color: #c9a3b2;
  font-size: 14px;
  letter-spacing: 1px;
}

/* ===== 移动端 ===== */
@media (max-width: 768px) {
  .hero { padding: 52px 18px 36px; }
  .hero-title { font-size: 34px; letter-spacing: 4px; }
  .hero-kicker { letter-spacing: 3px; }
  .hero-stats { gap: 26px; }
  .filters { gap: 8px; }
  .filter-btn { padding: 8px 18px; font-size: 13px; }

  .timeline-wrap { padding: 0 8px; }
  .timeline-hint { font-size: 12px; letter-spacing: 1px; }
  .timeline-track { gap: 18px; padding: 0 12vw; }
  .tl-item { width: 260px; }
  .scroll-btn { width: 34px; height: 34px; top: 44%; }
  .scroll-btn.prev { left: 4px; }
  .scroll-btn.next { right: 4px; }
  .scroll-btn svg { width: 16px; height: 16px; }
  .card-body { padding: 14px 16px 18px; }
  .card-title { font-size: 16px; }
  .card-desc { font-size: 13px; }

  .lb-figure { max-width: 94vw; }
  .lb-figure img { max-width: 94vw; max-height: calc(88vh - 150px); }
  .lb-close { top: 16px; right: 16px; }
  .lb-prev { left: 10px; }
  .lb-next { right: 10px; }
  .lb-btn { width: 40px; height: 40px; }

  .tl-card.add-card { min-height: 350px; }
  .act-btn { width: 30px; height: 30px; }
  .act-btn svg { width: 14px; height: 14px; }
  /deep/ .el-dialog { width: 92vw !important; }
  .new-cat { width: 100px; }
  .upload-box { height: 160px; }
}
</style>
